export const subtitles = {
    "1": {
        "startTime": 12.38,
        "endTime": 17.08,
        "transcript": "W-I-N-I-(F-R-E-D)",
        "translation": "W-I-N-I-(F-R-E-D)"
    },
    "2": {
        "startTime": 17.085,
        "endTime": 18.945,
        "transcript": "W-I-N-I?",
        "translation": "W-I-N-I?"
    },
    "3": {
        "startTime": 19.05,
        "endTime": 20.67,
        "transcript": "Last name-an-mi?",
        "translation": "What about your last name?"
    },
    "4": {
        "startTime": 20.675,
        "endTime": 22.115,
        "transcript": "Beans.",
        "translation": "Beans."
    },
    "5": {
        "startTime": 22.48,
        "endTime": 26.02,
        "transcript": "Beans? Beans-aartangqertuq, Bean-artarluni-llu.",
        "translation": "Beans? There are Beans [families], and also Bean [families]."
    },
    "6": {
        "startTime": 26.025,
        "endTime": 28.545,
        "transcript": "Beans, yaa, yaa. (Beans.)",
        "translation": "Beans, yes, yes. (Beans.)"
    },
    "7": {
        "startTime": 29.32,
        "endTime": 33.19,
        "transcript": "Kitak' im'unek",
        "translation": "So, with those things"
    },
    "8": {
        "startTime": 33.333,
        "endTime": 45.778,
        "transcript": "Qaillun wani makut taangamek arenqiallugutelget nunani kingunemteńi wani",
        "translation": "How will those who struggle with alcohol in our home villages"
    },
    "9": {
        "startTime": 46.214,
        "endTime": 53.003,
        "transcript": "Iciw' amlleret waten pilalriit: \"Qanrucunaituq tua-i. Tauna wani qanrutnermek taq'uq.\"",
        "translation": "You know many say this: \"He does not heed advice. He will stop getting advice.\""
    },
    "10": {
        "startTime": 53.015,
        "endTime": 60.082,
        "transcript": "Tamatum wani, tamakut wani ikayuryugngacimteńek qaillun qanrutqerkut.",
        "translation": "About that, please tell us how we can help those."
    },
    "11": {
        "startTime": 60.598,
        "endTime": 70.042,
        "transcript": "Tua-i-wa tuaten makut iqlutuuyulriit, kiingan-llu taangamek pivkenaku nallunrilkeput.",
        "translation": "We know those who do wrong things like that, and not only with alcohol."
    },
    "12": {
        "startTime": 70.546,
        "endTime": 76.991,
        "transcript": "Ayuqenrilnguut iqlutmun yuuyarat amllellriit.",
        "translation": "There are many, various ways to live wrong."
    },
    "13": {
        "startTime": 77.71,
        "endTime": 84.807,
        "transcript": "Umyuarteqsunaitukut waten ilamteńek, iciw' iqlutuuyugniluku.",
        "translation": "We should not think like this about those around us, you know, that [s]he is doing wrong."
    },
    "14": {
        "startTime": 85.087,
        "endTime": 90.154,
        "transcript": "\"Tua-i una piyunaituq. Arenqiatuq. Tua-i uitali.\"",
        "translation": "\"This one is difficult. He is unmanageable. Let him be.\""
    },
    "15": {
        "startTime": 90.164,
        "endTime": 92.887,
        "transcript": "Tuaten pinarqenritaakut.",
        "translation": "We must not do that."
    },
    "16": {
        "startTime": 94.021,
        "endTime": 101.732,
        "transcript": "Tua-i wiinga waniwa irniaqa, wangnek example-autekqerlua.",
        "translation": "Now, my child, using myself as an example."
    },
    "17": {
        "startTime": 101.738,
        "endTime": 110.371,
        "transcript": "Irniaqa wii waniwa tua-i cakneq ilamini qanrucunaunani cakneq yuuguq.",
        "translation": "Now, my child lives without heeding any advice compared to their peers."
    },
    "18": {
        "startTime": 110.704,
        "endTime": 112.97,
        "transcript": "Yuut-llu nalluvkenaku.",
        "translation": "And people know it."
    },
    "19": {
        "startTime": 112.98,
        "endTime": 116.202,
        "transcript": "Qanrut'nge'rmi niicuitqapiarluni.",
        "translation": "Though they are told, they're very disobedient."
    },
    "20": {
        "startTime": 117.032,
        "endTime": 123.176,
        "transcript": "Tua-ll' wii pikngamku tua-i qanrutengnaqura'rqa.",
        "translation": "Then since they are mine, I keep trying to tell them."
    },
    "21": {
        "startTime": 124.309,
        "endTime": 131.087,
        "transcript": "Iciw' kenekngamku waten, waten pingaunii, waten pisciiganii:",
        "translation": "You know, since I love them, I will not say this, cannot say this:"
    },
    "22": {
        "startTime": 131.094,
        "endTime": 135.305,
        "transcript": "\"Arenqiatuq una. Tua-i anli maaken enemnek.\"",
        "translation": "\"This one is unmanageable. Let them get out of my house here.\""
    },
    "23": {
        "startTime": 135.484,
        "endTime": 139.362,
        "transcript": "Tuaten pingaitua wii.",
        "translation": "I will not say that."
    },
    "24": {
        "startTime": 139.376,
        "endTime": 143.609,
        "transcript": "Wii pikaqa. Kia pikenritaa.",
        "translation": "They're mine. They're no one else's."
    },
    "25": {
        "startTime": 144.421,
        "endTime": 151.788,
        "transcript": "Wii irniaqluku anglicallruaqa.",
        "translation": "I raised them as my child."
    },
    "26": {
        "startTime": 152.243,
        "endTime": 163.376,
        "transcript": "Cali wii pikarkauluku qayutun tayim' anerteqellma taktaciatun, ellii-llu anerteqellran taktaciatun.",
        "translation": "They will also be mine for however long I am alive, and how long they are alive."
    },
    "27": {
        "startTime": 163.868,
        "endTime": 169.868,
        "transcript": "Niitenrilengraan qanruqu'urluku, qanrutengnaqluku.",
        "translation": "Though they don't listen, always instruct them, try to instruct them."
    },
    "28": {
        "startTime": 170.197,
        "endTime": 176.663,
        "transcript": "Wani mikellrani ayagnirluki tua-i qanrutengnaquraasqellaqait.",
        "translation": "Starting from when they're small, they tell us to try to instruct them."
    },
    "29": {
        "startTime": 177.147,
        "endTime": 180.936,
        "transcript": "Wiinga-w' mikelemni qanrutengnaqellruatnga.",
        "translation": "They tried to instruct me when I was small."
    },
    "30": {
        "startTime": 180.95,
        "endTime": 185.361,
        "transcript": "Cunawa qanrutengnaqellrulliniatnga uumikengramteng.",
        "translation": "Turns out, they tried to instruct me though I was infuriated with them."
    },
    "31": {
        "startTime": 185.375,
        "endTime": 191.186,
        "transcript": "Umyuamni cakneq iliikun uumikaqluki qanrutengnaqestenka.",
        "translation": "Sometimes in my mind, I'd be very infuriated with those who tried to instruct me."
    },
    "32": {
        "startTime": 191.535,
        "endTime": 194.713,
        "transcript": "Tau͡gaam kiuyuunaki.",
        "translation": "But I didn't talk back to them."
    },
    "33": {
        "startTime": 195.843,
        "endTime": 201.265,
        "transcript": "Ak'a qanrutellruatnga kiumralria-gguq waten ayuqeciquq.",
        "translation": "They already told me that one who talks back will be like this."
    },
    "34": {
        "startTime": 201.727,
        "endTime": 210.038,
        "transcript": "Cali qanrutellrulua ak'a qenqertellria-gguq waten qanrutniluni waten-gguq ayuqeciquq.",
        "translation": "They also told me that one who is angered when being told will be like this."
    },
    "35": {
        "startTime": 211.488,
        "endTime": 221.03,
        "transcript": "Iciwa angenrilnge'rma, ayaniriksailnge'rma tuaten pillerkaqa aliklallruaqa.",
        "translation": "You know, though I wasn't big, and though I wasn't active yet, I would be scared to be like that."
    },
    "36": {
        "startTime": 221.353,
        "endTime": 225.031,
        "transcript": "Tua-i-w' ak'a miklemni qanrutellruatnga.",
        "translation": "They already told me when I was small."
    },
    "37": {
        "startTime": 225.533,
        "endTime": 229.488,
        "transcript": "Niiculua-llu yuullrunricaaqua",
        "translation": "I also didn't live obediently"
    },
    "38": {
        "startTime": 229.499,
        "endTime": 234.688,
        "transcript": "Tau͡gaam imkut qanruyutenka eneqaqa'aqluki pilallruanka.",
        "translation": "But I would remember the traditional wisdom passed down to me."
    },
    "39": {
        "startTime": 237.22,
        "endTime": 244.464,
        "transcript": "Tuaten pimakuni yuum kinguneni nalluyagutevkenaku",
        "translation": "If a person is like that, without forgetting their past"
    },
    "40": {
        "startTime": 244.471,
        "endTime": 252.726,
        "transcript": "Tuaten tauna niicuilengraan pingnatuukuniu wangni assinruurtuq.",
        "translation": "Though that one is disobedient, if one doesn't give up, they are better than me."
    },
    "41": {
        "startTime": 253.47,
        "endTime": 256.537,
        "transcript": "Tua-i-wa elliin pikngamiu.",
        "translation": "Because [the child] is theirs."
    },
    "42": {
        "startTime": 256.814,
        "endTime": 268.166,
        "transcript": "Niitlalriakut-llu canek makunek neqkamteńek, qang'a-llu arnani wangkuta mingqaamteńek aturall'erkanek",
        "translation": "We also hear about our food supplies, and even for us women, what we sew into our clothes"
    },
    "43": {
        "startTime": 268.173,
        "endTime": 272.984,
        "transcript": "Kia-gguq piusngaitaakut. Wangkutnek-gguq pingnaqciqaput.",
        "translation": "They said no one will do it for us. They said we'll do it ourselves."
    },
    "44": {
        "startTime": 273.119,
        "endTime": 282.985,
        "transcript": "Tua-i tauna irniarput tuaten assiicukan, niicunricukan-llu, tua-i iqlutuuyukan",
        "translation": "If our child is bad like that, and is disobedient, does wrong"
    },
    "45": {
        "startTime": 282.991,
        "endTime": 285.991,
        "transcript": "Kia qagkut piusngailngataakut.",
        "translation": "It seems no one out there will do it for us."
    },
    "46": {
        "startTime": 286.0,
        "endTime": 291.345,
        "transcript": "Wangkuta wangkutnek tau͡gaam pingnaqluku piciqerput.",
        "translation": "Instead, we will try to [correct] them on our own."
    },
    "47": {
        "startTime": 293.355,
        "endTime": 301.088,
        "transcript": "Tua-i-gguq una tan'gaurluq au͡gkut yuut qaneryaraqekiit Yupiit.",
        "translation": "They said that the Yupiit back then had traditional wisdom about a boy."
    },
    "48": {
        "startTime": 301.093,
        "endTime": 305.371,
        "transcript": "Tan'gaurluq-gguq una cimiryuumauq.",
        "translation": "They said a boy can change."
    },
    "49": {
        "startTime": 305.495,
        "endTime": 311.895,
        "transcript": "Yuucini-gguq quinagyagutarkaugaa.",
        "translation": "They said he shall be repulsed by his lifestyle."
    },
    "50": {
        "startTime": 313.256,
        "endTime": 321.5,
        "transcript": "Una-gguq tauna-llu tua-i arcaqerluku alikelqa tamaani tua-i murilkengamki qaneryarat.",
        "translation": "They also said it would be especially so for the traditional wisdom [whose outcome] I feared when I became observant."
    },
    "51": {
        "startTime": 321.85,
        "endTime": 332.728,
        "transcript": "Una-gguq tau͡gken arnaq tuaten ayuqekuni capernarqenruuq cimillerkaa yuucini, piciryarani",
        "translation": "However, they said that if a woman is like that, it's harder for her to change her life, her ways"
    },
    "52": {
        "startTime": 332.738,
        "endTime": 339.161,
        "transcript": "Iciw' tamaaken kanaken ayagluku cimircetengnaqenrilkumteggu.",
        "translation": "You know, if we don't try to change her from back when she was [small]."
    },
    "53": {
        "startTime": 340.368,
        "endTime": 343.357,
        "transcript": "Cimiryaaqeciqaa-gguq waten.",
        "translation": "They said she would change like this."
    },
    "54": {
        "startTime": 344.092,
        "endTime": 354.615,
        "transcript": "Iciw' avani wangkutnek uingyuitellemteńek, uingyuitellermeggni.",
        "translation": "You know, back when we didn't choose our own husbands, when they didn't choose their own husbands."
    },
    "55": {
        "startTime": 355.368,
        "endTime": 360.334,
        "transcript": "Cimiryaaqeciqaa-gguq uum waten-llu ukurriskuni.",
        "translation": "They said that this would change her, and when she marries into another village."
    },
    "56": {
        "startTime": 361.146,
        "endTime": 366.38,
        "transcript": "Ak'anivkenaku-gguq ayuqucivialuni ataam teguciqaa.",
        "translation": "They said that before long, she would take back her bad behavior."
    },
    "57": {
        "startTime": 366.659,
        "endTime": 378.037,
        "transcript": "Tuatelluku arnani wangkuta ayagmek tua-i ellicangnaqluta-llu ayuqucirtungnaqluta-llu pitullinikaitkut.",
        "translation": "[?Because of] that, they would try to advise and instruct us women from the beginning."
    },
    "58": {
        "startTime": 378.463,
        "endTime": 381.996,
        "transcript": "Tua-i cali waniwa taangamek mat'umek",
        "translation": "Now, also, this alcohol"
    },
    "59": {
        "startTime": 382.638,
        "endTime": 389.905,
        "transcript": "Arcaqerluni man'a iqlutuuyaraq kayungengami",
        "translation": "Since this wrong way especially is getting stronger"
    },
    "60": {
        "startTime": 391.009,
        "endTime": 399.709,
        "transcript": "Tamiinun arnanun, angutnun-llu, nasaurlurnun, tan'gurrarnun-llu",
        "translation": "To everyone, women, and men, girls, and boys"
    },
    "61": {
        "startTime": 400.688,
        "endTime": 409.199,
        "transcript": "Tamana iqlutuuyaraq tua-i taangamek tapirluni kayutengami caknaanarivsiartuq.",
        "translation": "Since doing wrong is strengthened along with alcohol, it's become more difficult."
    },
    "62": {
        "startTime": 409.837,
        "endTime": 421.292,
        "transcript": "Tuaten wangkuta maa-i tuaten niicunrilengraan, taangamek-llu niicunrilengraan tua-i piqa'aqluku.",
        "translation": "For us like that, though they're disobedient like that, and they don't listen about alcohol, speak to them."
    },
    "63": {
        "startTime": 422.089,
        "endTime": 430.834,
        "transcript": "Taangarniluku-llu cellangengraan uumik'ngartevkenaku tangellrani.",
        "translation": "And just because they had alcohol, when they sober up, don't be infuriated with them where they can see."
    },
    "64": {
        "startTime": 432.454,
        "endTime": 436.22,
        "transcript": "Tau͡gaam kenkellerput nasvaumaluku.",
        "translation": "Instead, show our love."
    },
    "65": {
        "startTime": 436.29,
        "endTime": 445.012,
        "transcript": "Nallunricetengnaqluku kenkellerput iciw' aanaulriani kenkellerput.",
        "translation": "Try to let them know our love, you know, our motherly love."
    },
    "66": {
        "startTime": 445.023,
        "endTime": 455.312,
        "transcript": "Cali taangiqnginanrani uumikualuku pivkenaku.",
        "translation": "Also, do not be infuriated with them while they're drunk."
    },
    "67": {
        "startTime": 455.627,
        "endTime": 465.627,
        "transcript": "Cali enemteńi tamaani uitaluni avaqliqnginanemteńi tuaten piyukan qimagavkenaku.",
        "translation": "Also, if they do that in our home there while we're with them, do not run away from them."
    },
    "68": {
        "startTime": 466.753,
        "endTime": 474.575,
        "transcript": "Alingnarqengnaqluni-ll' piyaaqeciqngatuq. Ingluturtailkuni pingaituq.",
        "translation": "They may try to act scary. They won't do [anything] if they have no challengers."
    },
    "69": {
        "startTime": 478.257,
        "endTime": 483.121,
        "transcript": "Cali taangiqellran kinguani",
        "translation": "Also, after they've been drinking"
    },
    "70": {
        "startTime": 483.131,
        "endTime": 489.797,
        "transcript": "Assinrilngurmek-llu iciw' tamaani enemi-llu pingraan, wiinga-wa ayuquciqaqa:",
        "translation": "And, you know, though they do something bad in the house there, at least this is what I'm like:"
    },
    "71": {
        "startTime": 490.614,
        "endTime": 494.292,
        "transcript": "Qimanritengnaqluku, unitenritengnaqluku.",
        "translation": "Try not to run away from them, try not to leave them."
    },
    "72": {
        "startTime": 496.88,
        "endTime": 502.158,
        "transcript": "Iciw' alikenruaqa kingumni qaill' pillerkaa.",
        "translation": "You know, I'm more scared of what might happen after I leave."
    },
    "73": {
        "startTime": 503.636,
        "endTime": 511.525,
        "transcript": "Naliak-llu cumilnguluni uniskumteńi kiirrarmi-llu tamaani pikuni naliak-ll' cumilnguciqa?",
        "translation": "And if either is exasperated and we leave them to stay alone there, which will be exasperated?"
    },
    "74": {
        "startTime": 511.542,
        "endTime": 518.198,
        "transcript": "Qang'a-llu-qaa caskumek tegulluni ellminek akngirtengnaqluni piciquq.",
        "translation": "Or else, they may take a weapon and try to hurt themself."
    },
    "75": {
        "startTime": 518.565,
        "endTime": 527.399,
        "transcript": "Tua-i tau͡gaam tamaantengnaqlua ukanirpak wii yuugua, aipamni-llu.",
        "translation": "But I've always tried to stay there in my life, and in my spouse's."
    },
    "76": {
        "startTime": 529.097,
        "endTime": 536.041,
        "transcript": "Cali tuaten unuaquani tauna irniaqa taangiqellrukan",
        "translation": "Also, the next day if my child had been drunk"
    },
    "77": {
        "startTime": 536.464,
        "endTime": 542.608,
        "transcript": "Unuaquani qarulluku, egmian-llu nunurpek'naku.",
        "translation": "Comfort them the next day, and don't scold them right away."
    },
    "78": {
        "startTime": 544.041,
        "endTime": 553.941,
        "transcript": "Qarulluku imucetun pilallemtun camek quyacetaarluku, apluku caqatallranek-llu.",
        "translation": "Comfort them as I used to by trying to make them happy, and ask what they're going to do."
    },
    "79": {
        "startTime": 553.951,
        "endTime": 565.107,
        "transcript": "Tauna kiingan taangiqellra akwaugaq, qenqerrartellrukan-llu qenqertellra ciumek alairtevkenaku.",
        "translation": "Don't first bring up only his drinking the previous day, or his angry if he had gotten angry."
    },
    "80": {
        "startTime": 565.899,
        "endTime": 575.288,
        "transcript": "Wiinga-llu alingellrukuma tua tamakut pugerqevkenaki, tau͡gaam qarulluku.",
        "translation": "And if I had been scared, don't bring those up, but comfor them."
    },
    "81": {
        "startTime": 575.587,
        "endTime": 582.098,
        "transcript": "Qanerlalriit-llu maa-i tangerrlaqenka-llu wii hangover-arluki, yuussugluki.",
        "translation": "And they also say, and I see them, when they're hungover, yuussugluki."
    },
    "82": {
        "startTime": 582.108,
        "endTime": 586.871,
        "transcript": "Naliak-ll' yuussuinanermini qenqercukaarngatuq.",
        "translation": "And one of them seems to be irritable while hungover."
    },
    "83": {
        "startTime": 587.829,
        "endTime": 595.084,
        "transcript": "Tuatnanriqan tau͡gaam, anglaningkan, qanenqegcangluni-llu pikan",
        "translation": "Only when they're not like that anymore, when they have fun, and start to speak well"
    },
    "84": {
        "startTime": 595.096,
        "endTime": 601.685,
        "transcript": "Tuani-w' tua-i hangover-aallermini-ll' qanenqegcanrilngatuq.",
        "translation": "And they don't seem to speak well when hungover."
    },
    "85": {
        "startTime": 603.173,
        "endTime": 612.384,
        "transcript": "Qanenqegcarluni-llu pingkan nutaan, neryuniunrillrani-llu",
        "translation": "Only when they start speaking well, and don't expect it anymore"
    },
    "86": {
        "startTime": 612.395,
        "endTime": 620.228,
        "transcript": "Nutaan akwaugarpaumainanrani-llu qang'a-llu-qaa nutaan taumek qanrulluku.",
        "translation": "Then we should tell him what had happened the day before or whenever."
    },
    "87": {
        "startTime": 620.239,
        "endTime": 625.495,
        "transcript": "Nunurpek'naku-llu, qanenqegcaaraulluku tau͡gaam.",
        "translation": "And don't scold them, but speak to them kindly."
    },
    "88": {
        "startTime": 625.508,
        "endTime": 635.464,
        "transcript": "Qaillun elpet alingellren, qaillun-llu unitellerkaa alingellren nalqigulluku, nalqigutepiggluku.",
        "translation": "Explain, thoroughly explain, how you were scared, and how you were scared to leave them."
    },
    "89": {
        "startTime": 635.468,
        "endTime": 638.168,
        "transcript": "Nunuavkenaku.",
        "translation": "Don't scold them."
    },
    "90": {
        "startTime": 639.858,
        "endTime": 646.158,
        "transcript": "Naliak tuani umyuarniurciquq cakneq.",
        "translation": "One of them will be very regretful then."
    },
    "91": {
        "startTime": 646.925,
        "endTime": 649.336,
        "transcript": "Umyuarniurluni.",
        "translation": "They will be regretful."
    },
    "92": {
        "startTime": 649.361,
        "endTime": 653.883,
        "transcript": "Kenekniluku, kenkellren-llu nasvagluku.",
        "translation": "Say you love them, and show your love."
    },
    "93": {
        "startTime": 653.897,
        "endTime": 659.897,
        "transcript": "\"Kenekngamken, waten pisqenrilamken maantaurallruunga.\"",
        "translation": "\"Because I love you, I stayed here since I didn't want you to do this.\""
    },
    "94": {
        "startTime": 663.9,
        "endTime": 668.344,
        "transcript": "Tamana umyuarteqelqa qanrutekluku.",
        "translation": "I spoke about my thoughts."
    },
    "95": {
        "startTime": 670.671,
        "endTime": 680.138,
        "transcript": "\"Keneknilaqevnga-llu elpet. Kenkepigeskuvnga,\" iciw' tuaten pinqigtesqumavkenaku.",
        "translation": "\"You also say you love me. If you truly love me,\" you know, tell them not to do that again."
    },
    "96": {
        "startTime": 680.947,
        "endTime": 685.23,
        "transcript": "Cali agayulluku kesianek.",
        "translation": "Also, always pray for them."
    },
    "97": {
        "startTime": 685.24,
        "endTime": 690.852,
        "transcript": "Tuatequatevkenaku, tuatequatarkauvkenaku.",
        "translation": "Ask for them not to do that, that they shall not do that."
    },
    "98": {
        "startTime": 690.865,
        "endTime": 697.421,
        "transcript": "Umyuamni wii tuatequatarkauluki irnianka irniaqenritanka.",
        "translation": "I do not have my children to wish them to do that in my mind."
    },
    "99": {
        "startTime": 698.093,
        "endTime": 703.393,
        "transcript": "Kesianek tau͡gaam agayulluki, kaigalluki.",
        "translation": "But always pray for them, to ask on their behalf."
    },
    "100": {
        "startTime": 703.405,
        "endTime": 712.661,
        "transcript": "Tua-i tamana-llu kesianek maa-i yunraput makut tamakunek-llu niiterrlainaryunritliameng",
        "translation": "Probably since our children do not always want to listen to those"
    },
    "101": {
        "startTime": 712.673,
        "endTime": 717.928,
        "transcript": "Agayuvigmun-llu taqluteng ayagayuumiitlalriit.",
        "translation": "And they stop going to church and don't want to travel."
    },
    "102": {
        "startTime": 718.684,
        "endTime": 728.518,
        "transcript": "Tua-i tau͡gaam taumek pingraan wii qanrucuglaranka ukvesqelluki.",
        "translation": "In spite of that, I tell them to believe."
    },
    "103": {
        "startTime": 728.685,
        "endTime": 735.34,
        "transcript": "Cali waten cailkanek qanruciaqama, tua-i irniaqengramki-ll' qanruciaqama",
        "translation": "Also, when I instruct random people, and even when I instruct my children"
    },
    "104": {
        "startTime": 736.196,
        "endTime": 740.918,
        "transcript": "Ukveresqumaluki qanrutlaranka.",
        "translation": "I tell them to believe."
    },
    "105": {
        "startTime": 741.411,
        "endTime": 752.453,
        "transcript": "Kina imna camek pingnatulria, arcaqerluni-llu taangamek pingnatulria, qang'a-llu-qaa mat'umek melullermek pingnatulria",
        "translation": "Anyone who works hard for something, especially works for alcohol, and even one who works for smoking"
    },
    "106": {
        "startTime": 753.635,
        "endTime": 761.169,
        "transcript": "Camek ukvelirluni ikayurcirluni piarkaungatuq wangni.",
        "translation": "It seems they must have faith in something to help them to me."
    },
    "107": {
        "startTime": 762.863,
        "endTime": 769.296,
        "transcript": "Ukveritqapiarluni yuk ping'e'rmi kayungqerrngaituq.",
        "translation": "Though a person goes with absolutely no faith, they will have no strength."
    },
    "108": {
        "startTime": 771.084,
        "endTime": 774.395,
        "transcript": "Aipaagnek ukverluten.",
        "translation": "Believe one or the other."
    },
    "109": {
        "startTime": 774.503,
        "endTime": 781.136,
        "transcript": "Agayuvik, agayuviim piciryaraa ukvekluku.",
        "translation": "The church, believe in the ways of the church."
    },
    "110": {
        "startTime": 781.149,
        "endTime": 786.06,
        "transcript": "Ukvekesciigalkuvgu-llu agayuviim piciryaraa",
        "translation": "And if you can't believe in the ways of the church"
    },
    "111": {
        "startTime": 786.068,
        "endTime": 793.824,
        "transcript": "Yupiit qantuut agayuviim alerquutain cangalkenrilkaitnek.",
        "translation": "Yupiit speak of things that are no different from the commandments of the church."
    },
    "112": {
        "startTime": 793.886,
        "endTime": 801.126,
        "transcript": "Yupiit qaneryarait ukvekluki agayuviim piciryarai piyunrilkuvki.",
        "translation": "Believe in Yup'ik wisdom if you don't want to believe in the church's ways."
    },
    "113": {
        "startTime": 801.126,
        "endTime": 809.348,
        "transcript": "Yupiim qaneryaraa ukvekluku, atungnaqluku, cali niitengnaqluku.",
        "translation": "Try to believe in, practice, and obey Yup'ik wisdom."
    },
    "114": {
        "startTime": 809.931,
        "endTime": 818.22,
        "transcript": "Cangalliurngaituq Yup'ik iciw' ak'allaurteqalria apeskani yuum",
        "translation": "A Yup'ik, you know, who has gotten older will not be perturbed if a person asks them"
    },
    "115": {
        "startTime": 818.425,
        "endTime": 827.792,
        "transcript": "Ayuqucirtuutmek, ciunerkamek apeskani wangni quyaciquq cakneq, cakneq.",
        "translation": "If one asks them about traditional instructions, and advice for the future, to me, they will be very, very thankful."
    },
    "116": {
        "startTime": 828.014,
        "endTime": 831.947,
        "transcript": "Taumek apeskani quyaciquq wangni.",
        "translation": "If one asks them that, they will be happy to me."
    },
    "117": {
        "startTime": 832.344,
        "endTime": 842.288,
        "transcript": "Wii maa-i calingring'e'rma-llu yuut ap'artaqatnga cakneq qamaken ircaqumnek quyalua pitacimtun.",
        "translation": "Now, though I've stopped worked, when people ask me, I am completely thankful from inside in my heart."
    },
    "118": {
        "startTime": 842.299,
        "endTime": 847.51,
        "transcript": "Qaneryararrarmek Yup'igtarrarmek",
        "translation": "A little piece of Yup'ik wisdom"
    },
    "119": {
        "startTime": 847.512,
        "endTime": 855.19,
        "transcript": "Waniwa arnangiaraurcama arcaqerlua imkut Yup'igtaat tuarpiaq kayuriluteng wangnun taigut.",
        "translation": "Especially not that I've become an old woman, it truly seems that that Yup'ik wisdom has come to be stronger."
    },
    "120": {
        "startTime": 855.579,
        "endTime": 860.89,
        "transcript": "Tua-i-wa cangallrunritliniata mat'umi agayuviim Qaneryaraani.",
        "translation": "It's because they're no different from the church's Bible."
    },
    "121": {
        "startTime": 860.908,
        "endTime": 871.13,
        "transcript": "Tua-i cakneq kayuqapiggluteng assiqapiggluteng-llu wangni qaneryaraulliniut au͡gkut Yupiit qaneryarait, alerquutait.",
        "translation": "They are very strong and good pieces of wisdom to me, those pieces of Yup'ik wisdom, instructions."
    },
    "122": {
        "startTime": 871.404,
        "endTime": 876.038,
        "transcript": "Tamakut tua-i taumek tuaten qanertua.",
        "translation": "That's why I said that."
    },
    "123": {
        "startTime": 876.051,
        "endTime": 883.428,
        "transcript": "Cali eglerrnginanemni ukani irnianka ukut waniw' anglilriit.",
        "translation": "Also, as I've lived up to now, my children are now grown."
    },
    "124": {
        "startTime": 883.435,
        "endTime": 887.224,
        "transcript": "Nayunrirlua-llu, ellmeggnek yuungnatugluteng.",
        "translation": "And they're not with me, making their own living."
    },
    "125": {
        "startTime": 888.302,
        "endTime": 896.936,
        "transcript": "Qanrutlaranka peng'gartesqevkenateng-ll' waten-llu uluumavkenii tau͡gaam pituatnga.",
        "translation": "I tell them not to worry, but they also do not ignore me."
    },
    "126": {
        "startTime": 897.591,
        "endTime": 904.058,
        "transcript": "Waniwa-llu phone-angamta phone-artura'aqlua-llu pituatnga.",
        "translation": "And now that we have phones, they always call me on the phone."
    },
    "127": {
        "startTime": 904.068,
        "endTime": 908.323,
        "transcript": "Phone-aitevkangnaqlua-llu pilaraatnga nallunaunateng.",
        "translation": "And it's clear that they try to keep me from [not] having a phone."
    },
    "128": {
        "startTime": 908.691,
        "endTime": 918.691,
        "transcript": "Tua-i waten phone-arlua-llu tuqluraqamegteńga peng'gartesqevkenateng-llu piaqatnga",
        "translation": "When they call me on the phone like this, and when they tell me not to worry about them"
    },
    "129": {
        "startTime": 919.396,
        "endTime": 923.129,
        "transcript": "Waten, waten pituanka:",
        "translation": "I tell them this:"
    },
    "130": {
        "startTime": 925.601,
        "endTime": 931.245,
        "transcript": "\"Camek-mi peng'garciqsiken taangam avatiini?\"",
        "translation": "\"What will I worry about you other than alcohol?\""
    },
    "131": {
        "startTime": 931.263,
        "endTime": 940.885,
        "transcript": "Wangni taangam avatii camek peng'garucirkaitua",
        "translation": "To me, there is nothing to worry about other than alcohol"
    },
    "132": {
        "startTime": 941.58,
        "endTime": 944.269,
        "transcript": "Iciw' nangteqenrilkata.",
        "translation": "You know, if they're not sick."
    },
    "133": {
        "startTime": 946.153,
        "endTime": 952.753,
        "transcript": "Tua-i-llu ataam cali wii qanrutaqluki iciw' taangaqusqumanricaaqluki.",
        "translation": "Then I also tell them again that I don't want them to be alcoholic."
    },
    "134": {
        "startTime": 952.76,
        "endTime": 960.038,
        "transcript": "Makut-llu aanait, irnianka irniangelriit taangaqusqumanritanka.",
        "translation": "I also don't want their mothers, my children with children, to be alcoholic."
    },
    "135": {
        "startTime": 961.038,
        "endTime": 968.76,
        "transcript": "Tangalirtungnaqluki amllernek assiilngurnek, assilriarunricaaqua.",
        "translation": "I try to [?show] them many bad things, I am not good."
    },
    "136": {
        "startTime": 968.772,
        "endTime": 972.727,
        "transcript": "Tangalirtungnaqluki anglicangnaqellruanka.",
        "translation": "I tried to raise them [?by showing them]."
    },
    "137": {
        "startTime": 972.735,
        "endTime": 979.602,
        "transcript": "Taangangnaqevkenii, agayuvigmun-llu ayautengnaqaqluki.",
        "translation": "I tried not to drink alcohol, and tried to take them to church."
    },
    "138": {
        "startTime": 979.997,
        "endTime": 984.975,
        "transcript": "Tua-llu tuaten phone-mi qanrutaqatnga pilaranka",
        "translation": "Then when they tell me on the phone, I tell them"
    },
    "139": {
        "startTime": 984.984,
        "endTime": 994.106,
        "transcript": "Qang'a-llu-qaa tuaten akwaugaani-llu taangiqellruaqan arcaqerluki makut angutet pinarqelliniut.",
        "translation": "Or when they had been drinking the previous day, these men must especially be told."
    },
    "140": {
        "startTime": 995.826,
        "endTime": 998.559,
        "transcript": "Qanrutellruaqamki pilaranka",
        "translation": "When I tell them, I say"
    },
    "141": {
        "startTime": 998.567,
        "endTime": 1007.112,
        "transcript": "\"Kenekngamci ukanirpak wii taangangnaqellrunritua nanikuasqenrilamci.\"",
        "translation": "\"Because I love you, I've never drank alcohol since I didn't want you to feel helpless.\""
    },
    "142": {
        "startTime": 1007.123,
        "endTime": 1012.956,
        "transcript": "Tangerrlaata-llu ilameggnek taangiqellrianek-llu angayuqaalegnek.",
        "translation": "Also because they see their peers with alcoholic parents."
    },
    "143": {
        "startTime": 1012.969,
        "endTime": 1021.569,
        "transcript": "Kusguryugluteng-llu itrutlaata nerucugluki-llu, mom-ii-gguq daddy-a-llu taangiquq.",
        "translation": "Also because they bring [children] out of compassion and want to eat with them, saying their mom and daddy are drunk."
    },
    "144": {
        "startTime": 1021.797,
        "endTime": 1028.841,
        "transcript": "Tua-i takumcuyullratnek cakneq quyatullruunga cakneq ilumnek.",
        "translation": "I would be very thankful for their compassion."
    },
    "145": {
        "startTime": 1030.102,
        "endTime": 1034.069,
        "transcript": "Tua-i qanrutlaqenka tamatumek tuaten.",
        "translation": "That's what I would tell them."
    },
    "146": {
        "startTime": 1034.692,
        "endTime": 1041.937,
        "transcript": "\"Kenekngamci wii nanikuavkangnaqluci anglicallrunritamci.",
        "translation": "\"Because I love you, I did not try to make you feel helpless as I raised you."
    },
    "147": {
        "startTime": 1042.4,
        "endTime": 1047.941,
        "transcript": "\"Akinaurlua-llu elpeci kenkepigglua",
        "translation": "\"Repay me out of great love"
    },
    "148": {
        "startTime": 1048.51,
        "endTime": 1059.287,
        "transcript": "\"Tuaten taangamek tamatumek pisqumanritlemnek umyuaqlua pinritengnaqaqluci pici.\"",
        "translation": "\"Think of me, and try not to abuse that alcohol that I don't want you to get into.\""
    },
    "149": {
        "startTime": 1059.293,
        "endTime": 1065.304,
        "transcript": "Tua-i taumek tuaten qanrutlaranka taumek akinauresqumalua.",
        "translation": "That's what I tell them, to repay me like that."
    },
    "150": {
        "startTime": 1066.984,
        "endTime": 1070.014,
        "transcript": "Kenkellriani irniaq",
        "translation": "To those who love a child"
    },
    "151": {
        "startTime": 1070.543,
        "endTime": 1076.554,
        "transcript": "Nunurleraluki-llu waniw' pilaqeput irniaput.",
        "translation": "And we also scold our children."
    },
    "152": {
        "startTime": 1076.556,
        "endTime": 1080.278,
        "transcript": "Iciw' wiinga-w' pillrukenka avaqliqlemni.",
        "translation": "You know, I did that when they were with me."
    },
    "153": {
        "startTime": 1080.294,
        "endTime": 1084.35,
        "transcript": "Amta-ll' kenekluki, amta-ll' nunurlenricunaunanki.",
        "translation": "Yet we love them, yet we shouldn't keep from scolding them."
    },
    "154": {
        "startTime": 1084.364,
        "endTime": 1092.486,
        "transcript": "Nunurlerraarluki ataam qarulluki, kenkelqa imna nasvagluku.",
        "translation": "After scolding them, comfort them again, showing my love."
    },
    "155": {
        "startTime": 1093.031,
        "endTime": 1098.442,
        "transcript": "Tauna-llu im' nunurleruteka qanrutekluku, \"Tuaten pisqenrilamken.\"",
        "translation": "And I tell them about what I scolded about, \"Because I don't want you to do that.\""
    },
    "156": {
        "startTime": 1099.02,
        "endTime": 1104.965,
        "transcript": "Watua maa-i arcaqerluteng caperrnarivsiartut waten.",
        "translation": "Especially these days, they've become more difficult like this."
    },
    "157": {
        "startTime": 1106.109,
        "endTime": 1116.642,
        "transcript": "Wangkuta Yup'igni, Kass'am-llu piciryaraan akuliigni qukaani tuarpiaq maku'urluut.",
        "translation": "It truly seems that these poor people are in between our Yup'ik and Western ways."
    },
    "158": {
        "startTime": 1116.646,
        "endTime": 1123.213,
        "transcript": "Wiinga waniwa tutgara'urluunka ukut tua-i akuliigni tuar uitalriit.",
        "translation": "It seems my grandchildren here are in between them."
    },
    "159": {
        "startTime": 1123.713,
        "endTime": 1134.713,
        "transcript": "Pingraan tau͡gaam tua-i nani maani-llu qitevterrlainarluteng-llu maa-i tutgara'urluput, wiinga-w' tutgara'urluunka pingut.",
        "translation": "In spite of that, and in places here, our grandchildren are starting to speak only in English, at least my grandchidlren are."
    },
    "160": {
        "startTime": 1135.228,
        "endTime": 1142.883,
        "transcript": "Tua-i puqigtacirramtun nani maani qanrusnguaqangnaqa'artaqluki pilaryaaqanka.",
        "translation": "I do instruct them in some places here as fluently as I can."
    },
    "161": {
        "startTime": 1142.95,
        "endTime": 1147.306,
        "transcript": "Tuarpiaq niicugniyuumiilnguut-llu pilkiagaqluteng.",
        "translation": "And it truly seems that it shows they don't want to listen."
    },
    "162": {
        "startTime": 1147.315,
        "endTime": 1152.248,
        "transcript": "Qang'a-llu-qaa piciunrilkelkialuki tuaten cat pilkiagaqluteng.",
        "translation": "Or, they even show that they don't think things are true."
    },
    "163": {
        "startTime": 1152.422,
        "endTime": 1158.81,
        "transcript": "Tau͡gaam tua-i pingraata tuaten pingnaqaqluki pinarqelliniut.",
        "translation": "But though they do that, we must try with them."
    },
    "164": {
        "startTime": 1159.466,
        "endTime": 1167.4,
        "transcript": "Cali tuaten arcaqalriamek niicunritniluku tuatequanarqenritliniuq.",
        "translation": "Also, we must especially not do that just because they don't want to listen."
    },
    "165": {
        "startTime": 1167.628,
        "endTime": 1176.961,
        "transcript": "Niitenrilengraan cam iliini umyuarniurciquq qaruqurteḿinek uumek.",
        "translation": "Though they don't listen, they will someday have regrets about one that encouraged them."
    },
    "166": {
        "startTime": 1176.977,
        "endTime": 1182.622,
        "transcript": "Keneksukluni cam iliini umyuarteqciquq, umyuarteqciqliniuq.",
        "translation": "Someday, they will think that they were treated with love."
    },
    "167": {
        "startTime": 1182.951,
        "endTime": 1196.128,
        "transcript": "Wiinga tua-i imkut anglillemni kenkenricuklua umyuarteqlallrulrianga tamakut tuaten qanrutestenka.",
        "translation": "When I was growing up, I used to think that those who instructed me like that didn't love me."
    },
    "168": {
        "startTime": 1197.574,
        "endTime": 1201.808,
        "transcript": "Cunawa keneklua qanrutlallrullinikiitnga.",
        "translation": "It turned out, they instructed me out of love."
    },
    "169": {
        "startTime": 1201.821,
        "endTime": 1208.31,
        "transcript": "Tamana tua naspertukluku tamaa-i qanrutengnaqu'urlaranka.",
        "translation": "Considering that, I always try to instruct them."
    },
    "170": {
        "startTime": 1208.316,
        "endTime": 1211.694,
        "transcript": "Makuungraata-llu cailkaungraata",
        "translation": "And even when they're random people here"
    },
    "171": {
        "startTime": 1212.857,
        "endTime": 1223.546,
        "transcript": "Iciw' counselor-aulqa nallunrilamegteggu kingunemni-wa piqerlaraatnga.",
        "translation": "You know, because they knew I was a counselor, they come to me back home."
    },
    "172": {
        "startTime": 1223.75,
        "endTime": 1230.661,
        "transcript": "Iluteqaqameng-llu, qang'a-llu-qaa yunraunrilnge'rmeng, qan'ga-llu-qaa temirteńgunge'rmeng.",
        "translation": "And when they're sad, or even when they're not children, or even when they're adults."
    },
    "173": {
        "startTime": 1231.4,
        "endTime": 1243.412,
        "transcript": "Tamanek ap'artestenka cakneq ilumnek iciw' tunrirlua piunrilkevkenii uumek cellangcarviklua pianga.",
        "translation": "With those that ask me, I am very embarrassed inside, you know, because I don't feel capable when someone comes to me for advice."
    },
    "174": {
        "startTime": 1243.423,
        "endTime": 1248.467,
        "transcript": "Cakneq tunrirlua pitacirramtum pingnatuglaranka.",
        "translation": "I am completely embarrassed as I do my best with them."
    },
    "175": {
        "startTime": 1248.652,
        "endTime": 1257.519,
        "transcript": "Tua-i kasngukevkenaku-llu yuuciqa, ikiuyugluteng-llu irnianka pillrat kasngukevkenaku.",
        "translation": "I am not ashamed of my life, and I am not ashamed of how improper my children were."
    },
    "176": {
        "startTime": 1257.524,
        "endTime": 1260.224,
        "transcript": "Tamana-llu example-autekluku.",
        "translation": "I also use that as an example."
    },
    "177": {
        "startTime": 1260.239,
        "endTime": 1264.483,
        "transcript": "Tua-i-wa tayima akleng tauna qanrutestailkuni",
        "translation": "It's because, poor thing, if that person has no one to tell them"
    },
    "178": {
        "startTime": 1264.492,
        "endTime": 1272.358,
        "transcript": "Kiirrarmi tuaten ayuqsukluni umyuarteqluni tua-i assingnatugluni-llu naliak pingaituq.",
        "translation": "If they think they're the only ones like that, they will not try to be good."
    },
    "179": {
        "startTime": 1272.509,
        "endTime": 1277.52,
        "transcript": "Tua-i tamakut-llu irnianka qanrutekluki",
        "translation": "I also talk about my children"
    },
    "180": {
        "startTime": 1277.532,
        "endTime": 1285.399,
        "transcript": "Arenqilirrlainarluni, aanaulria arenqilirrlainarluni, anglanirrlainarluni-llu",
        "translation": "Always doing well, a mother always doing well and having fun"
    },
    "181": {
        "startTime": 1285.405,
        "endTime": 1293.471,
        "transcript": "Ukunek quyakellerminek irniamek irniurngaicugnarquq, anglicaringaicugnarquq.",
        "translation": "She will not have these children that she's thankful for, or raise them [always doing well]."
    },
    "182": {
        "startTime": 1293.478,
        "endTime": 1302.578,
        "transcript": "Cam iliini iluteqeqaqluni, cam iliini cakniuqaqluni yuuciqsugnarquq.",
        "translation": "She will likely live sometimes being sad, sometimes struggling."
    },
    "183": {
        "startTime": 1304.889,
        "endTime": 1307.789,
        "transcript": "Alingcirarautngunrituq.",
        "translation": "This is not to instill fear."
    },
    "184": {
        "startTime": 1307.804,
        "endTime": 1313.438,
        "transcript": "Tau͡gaam wiinga atullruamku tua-i tuaten ayuquciatun qanrutkaqa.",
        "translation": "But since I've experienced it, I talked about how it's like that."
    },
    "185": {
        "startTime": 1313.449,
        "endTime": 1314.627,
        "transcript": "Tua-llu?",
        "translation": "How was that?"
    },
    "186": {
        "startTime": 1314.64,
        "endTime": 1315.64,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "187": {
        "startTime": 1318.053,
        "endTime": 1320.086,
        "transcript": "Oh, nangqatalliniuq.",
        "translation": "Oh, it's going to run out."
    }
};